import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Table, Alert } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { DailyDropdown } from '../../../Constant';
import DropdownCommon from '../../Common/Dropdown';
import { getUsers } from '../../../api/userCheckIn';

const Activities = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch users from API
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const response = await getUsers({ page: 1, limit: 6 });
        
        // Ensure userData is always an array
        let userData = [];
        if (response?.data?.users && Array.isArray(response.data.users)) {
          userData = response.data.users;
        } else if (response?.data && Array.isArray(response.data)) {
          userData = response.data;
        } else if (response?.users && Array.isArray(response.users)) {
          userData = response.users;
        } else if (Array.isArray(response)) {
          userData = response;
        }
        
        setUsers(userData);
        setError(null);
      } catch (err) {
        console.error('Error fetching users:', err);
        setError(err.message || 'Failed to load users');
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return (
    <Card>
      <CardHeader className='card-header card-no-border'>
        <div className='header-top'>
          <H5 className='m-0'>User Activities</H5>
          <div className='card-header-right-icon'>
            <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} />
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 activity-card'>
        {loading ? (
          <div className='text-center p-3'>
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : error ? (
          <Alert color='danger' className='m-3'>
            <i className='fa fa-exclamation-triangle me-2'></i>
            {error}
          </Alert>
        ) : users.length === 0 ? (
          <Alert color='info' className='m-3'>
            <i className='fa fa-info-circle me-2'></i>
            No users found. Please check your API connection.
          </Alert>
        ) : (
          <div className='appointment-table customer-table table-responsive'>
            <Table className='table table-bordernone'>
              <tbody>
                {users.map((user, i) => (
                  <tr key={user.userId || i}>
                    <td>
                      {user.avatar ? (
                        <img 
                          className='img-fluid img-40 rounded-circle me-2' 
                          src={user.avatar} 
                          alt={user.name || 'user'}
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      ) : (
                        <div className='img-fluid img-40 rounded-circle me-2 bg-light d-flex align-items-center justify-content-center' style={{ width: '40px', height: '40px' }}>
                          <span className='text-primary fw-bold'>{user.name?.charAt(0) || 'U'}</span>
                        </div>
                      )}
                    </td>
                    <td className='img-content-box'>
                      <Link className='d-block f-w-500' to={`${process.env.PUBLIC_URL}/app/users/profile`}>
                        {user.name || 'Unknown User'}
                      </Link>
                      <span className='f-light'>
                        User ID: {user.userId?.substring(0, 12)}...
                      </span>
                    </td>
                    <td className='text-end'>
                      <span className={`font-${user.followedOA ? 'success' : 'secondary'}`}>
                        {user.followedOA ? 'Followed' : 'Not Follow'}
                      </span>
                      <span className='d-block f-light'>{user.phone || 'No phone'}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default Activities;
